import Modal from "./Modal.tsx";
import {InformationCircleIcon} from "@heroicons/react/24/outline";
import {IModalProps} from "./IModalProps.ts";

const ChannelUnavailableModal = ({isOpen, onClose}: IModalProps) => {
    return (
        isOpen &&
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="p-4 flex items-center space-x-4">
                <InformationCircleIcon className="w-10 h-10  md:w-7 md:h-7"/>
                <p className="border-l pl-4">
                    Kanał nie jest dostępny w serwisie Beskid Media GO
                </p>
            </div>
        </Modal>
    )
};

export default ChannelUnavailableModal;